export default __webpack_public_path__ + "static/media/check.821d5be2.svg";